import { IGeneralState } from '../state/general-state';
import { IAction } from '../state/app-state';
import { AuthActionType } from '../../shared/enums/auth-action-types';

const initialState: IGeneralState = {
    showLoader: false,
};

export const GeneralReducer = (state: IGeneralState = initialState, action: IAction<any>): IGeneralState => {
    switch (action.type) {
        case AuthActionType.SHOW_LOADER:
            return {
                ...state,
                showLoader: action.payload,
            };
        default:
            return state;
    }
};
